export const MIN_SEARCH_LENGTH = 2
export const SEARCH_PROVIDERS = {
  google: {
    url: 'https://google.com/search?q=',
    name: 'Google',
  },
}
